import{gql as e}from"graphql-tag";import{MessageFragmentDoc as s,MessageResourceFragmentDoc as o,MessageMeditationResourceFragmentDoc as r,MessageProgramResourceFragmentDoc as a}from"./fragments.generated.es.js";const m=e`
    subscription onNewMessage {
  onNewMessage {
    ...message
  }
}
    ${s}
${o}
${r}
${a}`;export{m as OnNewMessageDocument};
//# sourceMappingURL=onNewMessageSubscription.generated.es.js.map
